import { useSelector } from 'react-redux'
import {
  setDialogAction,
  uiGlobalSelector,
} from '@/state/ui/global/slices/index.slices'
import { useAppDispatch } from '@/state'

import { authSelector } from '@/state/auth/slices/index.slices'

export const useUsersDialog = () => {
  const dispatch = useAppDispatch()

  const { formMode, dialog, dialogs } = useSelector(uiGlobalSelector)

  const { userSession } = useSelector(authSelector)

  const toggleDialog = (open: boolean, id?: string) => {
    dispatch(setDialogAction({ open, id }))
  }

  return {
    dialog,
    dialogs,
    toggleDialog,
    formMode,
    userSession,
  }
}
